import React from "react";
import { Box, CssBaseline } from "@mui/material";
import { ThemeProvider, createTheme, alpha } from "@mui/material/styles";
import { Navbar } from "./Components/Navbar";
import { HeroSection } from "./Components/HeroSection";
import { FeaturesSection } from "./Components/FeaturesSection";
import { Footer } from "./Components/Footer";

// Tema Escuro (Dark Mode) com acentos ciano
const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#00BCD4", // Ciano
      dark: "#00838F",
      light: "#4DD0E1",
      contrastText: "#000000",
    },
    secondary: {
      main: "#FF4081", // Rosa
      dark: "#C51162",
      light: "#FF80AB",
      contrastText: "#ffffff",
    },
    background: {
      default: "#121212",
      paper: "#1E1E1E", // Um pouco mais claro que o default
    },
    text: {
      primary: "#E0E0E0",
      secondary: "#B0B0B0",
    },
    divider: alpha("#ffffff", 0.12),
  },
  typography: {
    fontFamily: '"Roboto Mono", "monospace"', // Fonte monoespaçada para um look tech
    h1: {
      fontWeight: 700,
    },
    h2: {
      fontWeight: 700,
    },
    h3: {
      fontWeight: 600,
    },
    button: {
      textTransform: "uppercase",
      fontWeight: 700,
      letterSpacing: "0.05em",
    },
    overline: {
      fontWeight: 600,
      letterSpacing: "0.1em",
    },
  },
  shape: {
    borderRadius: 6,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          padding: "10px 25px",
        },
        containedPrimary: {
          color: "#000000",
          "&:hover": {
            backgroundColor: "#00838F",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none", // Remover gradientes padrão do Paper em dark mode
        },
        outlined: {
          borderColor: alpha("#ffffff", 0.2),
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: alpha("#1E1E1E", 0.85),
          backdropFilter: "blur(10px)",
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          "& .MuiOutlinedInput-root": {
            backgroundColor: alpha("#ffffff", 0.05),
            "& fieldset": {
              borderColor: alpha("#ffffff", 0.2),
            },
            "&:hover fieldset": {
              borderColor: alpha("#ffffff", 0.4),
            },
            "&.Mui-focused fieldset": {
              borderColor: "#00BCD4", // Cor primária
            },
          },
        },
      },
    },
  },
});

export const LandingPages0006 = () => {
  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: theme.palette.background.default,
        }}
      >
        <CssBaseline />
        <Navbar />
        <HeroSection />
        <FeaturesSection />
        <Footer />
      </Box>
    </ThemeProvider>
  );
};
